<template>
  <div class="dashboard-quick-access">
    <dashboard-mobile-profile/>

    <div class="row no-gutters quick-grid">
      <div class="col-lg-3 col-md-6 col-6 p-2">
        <router-link class="text-decoration-none" :to="{name:'Profile'}">
          <div class="quick-tile">
            <img src="../../../../public/profile2.webp" alt="">
            <span>پروفایل</span>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-6 p-2">
        <router-link class="text-decoration-none" :to="{name:'Home'}">
          <div class="quick-tile">
            <img src="../../../../public/back.webp" alt="">
            <span>بازگشت به سایت</span>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-6 p-2">
        <router-link class="text-decoration-none" :to="{name: 'UserChats'}">
          <div class="quick-tile">
            <img src="../../../../public/chat.webp" alt="">
            <span>چت های من</span>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-6 p-2">
        <router-link class="text-decoration-none" :to="{name:'WishListUser',params:{user:profile.id}}">
          <div class="quick-tile">
            <img src="../../../../public/fav.webp" alt="">
            <span>لیست موردعلاقه ها</span>
          </div>
        </router-link>
      </div>

      <div
        class="col-lg-6 col-12 p-2"
        v-if="findAttributeOnSiteInfo('show_users_orders_in_main_dashboard')[0] == 1"
      >
        <router-link class="text-decoration-none d-block h-100" :to="{name:'UserOrders'}">
          <My0rders class="quick-embed"/>
        </router-link>
      </div>

      <div
        class="col-lg-6 col-12 p-2"
        v-if="findAttributeOnSiteInfo('show_users_orders_in_main_dashboard')[0] == 1"
      >
        <router-link class="text-decoration-none d-block h-100" :to="{name:'mycourse'}">
          <MyCourse class="quick-embed"/>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DashboardMobileProfile from "./DashboardMobileProfile.vue"
import My0rders from "@/plugin/views/dashboard/MyOrders.vue"
import MyCourse from "@/plugin/components/dashboard/Course/MyCourse.vue"
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo"

export default {
  name: "DashboardQuickAccess",
  components: {DashboardMobileProfile, My0rders, MyCourse},
  computed: {
    ...mapGetters({
      profile: "User/getProfile",
    }),
  },
  methods: {
    findAttributeOnSiteInfo,
  },
}
</script>

<style scoped>
.dashboard-quick-access {
  overflow-x: hidden;
  max-width: 100%;
}

.quick-grid {
  margin: 0;
}

.quick-tile {
  position: relative;
  overflow: hidden;
  background: #1e1e1e;
  color: #fff;
  border-radius: 18px;
  min-height: 124px;
  padding: 16px 10px 14px;
  text-align: center;
  box-shadow: 0 10px 22px rgba(30, 30, 30, 0.14);
}

.quick-tile::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px);
  background-size: 12px 12px;
  pointer-events: none;
}

.quick-tile > * {
  position: relative;
  z-index: 1;
}

.quick-tile img {
  height: 56px;
  width: auto;
  max-width: 70%;
  object-fit: contain;
  margin-bottom: 8px;
}

.quick-tile i {
  display: block;
  font-size: 40px;
  margin: 8px 0 10px;
  color: #fff;
}

.quick-tile span {
  display: block;
  font-weight: 800;
  font-size: 13px;
  color: #fff;
}

.quick-embed {
  overflow: hidden;
  border-radius: 18px;
  max-width: 100%;
}
</style>
